import { concat } from 'lodash';

import { SCOPES } from 'constants/roles';

import PersonMyTeam from './navigation-sys-admin-instances';

export default {
  type: 'section',
  scope: SCOPES.SYS_ADMIN,
  navigationIcon: 'far fa-shield-alt',
  label: 'label.system_administration',
  url: '/system-administration/instances',
  name: 'system-administration-instances-list',
  pages: concat(
    PersonMyTeam,
  ),
};



// WEBPACK FOOTER //
// ./src/data/navigations/system-administration/index.js